import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

//import theme from '@ecp/common/src/style/theme/default';
import { FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import Dropdown from '@ecp/common/src/components/dropdown/mo/Dropdown';

import GoodCtaButtonOptionItem from '@mo-pages/good/components/cta/option/GoodCtaButtonOptionItem';
import { useTheme } from 'styled-components';

const GoodCtaButtonOptionItemList = ({
  itemNodeList,
  stockManagement,
  onSelect,
  placeholder = '옵션을 선택하세요.',
}) => {
  const theme = useTheme();
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    setSelected(null);
  }, [itemNodeList]);

  const itemList = useMemo(
    () =>
      itemNodeList?.map((item) => ({
        ...item,
        key: item?.itemKey,
        label: item?.itemName,
        stockManagement,
        disabled: item?.leafItem?.soldOut || item?.leafItem?.stopSale,
      })),
    [itemNodeList, stockManagement]
  );
  const handleSelect = (item) => {
    setSelected(item);
    if (item?.leafItem) {
      onSelect(item?.leafItem);
    }
  };

  return (
    <FlexBoxColumn width={'100%'}>
      <Dropdown
        items={itemList}
        onChange={handleSelect}
        value={selected}
        placeholder={itemList[0].itemLabel}
        itemSlot={GoodCtaButtonOptionItem}
        openBorderColor={theme.color.primary}
        itemsMaxHeight={'122px'}
      />
      {!selected?.leafItem && selected?.childNodeList?.length > 0 && (
        <>
          <Spacing top={6} />
          <GoodCtaButtonOptionItemList
            itemNodeList={selected?.childNodeList}
            onSelect={onSelect}
            stockManagement={stockManagement}
            placeholder={placeholder}
          />
        </>
      )}
    </FlexBoxColumn>
  );
};

GoodCtaButtonOptionItemList.propTypes = {
  itemNodeList: PropTypes.array,
  stockManagement: PropTypes.bool,
  onSelect: PropTypes.func,
  placeholder: PropTypes.string,
};
export default GoodCtaButtonOptionItemList;
